export default "__VITE_ASSET__BB_eoZfJ__"